import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { fg } from '@atlaskit/platform-feature-flags';

export type ForgeUIRuntimeType = 'webworker' | 'iframe' | 'iframev2';

/**
 * Contributes the rendering runtime to `forgeUIAttributes` for every Forge UI
 * analytics event fired by descendant components.
 */
export const ForgeUIRuntimeAnalyticsContext = ({
	runtime,
	children,
}: {
	children: React.ReactNode;
	runtime: ForgeUIRuntimeType;
}): React.JSX.Element => {
	// Gate the attribute on the bridge-core v2 rollout: only emit `runtime` once
	// `forge-ui-bridge-core-reset` is on, leaving legacy v1 analytics untouched.
	if (!fg('forge-ui-bridge-core-reset')) {
		return <>{children}</>;
	}

	return <AnalyticsContext data={{ forgeUIAttributes: { runtime } }}>{children}</AnalyticsContext>;
};
